export const blockIconsMapsMedicalServicesNew = (
	<span className='material-symbols-outlined'>medical_services</span>
);
